import { Injectable } from "@angular/core";
import {LmEventNames, LmEvents} from "../domain";
import {LoggerService} from "./logger.service";

@Injectable({ providedIn: 'root' })
export class ParentWindowMessagingService {
  constructor(
    private readonly log: LoggerService
  ) { }

  /**
   * Sends a Locus Map event to the parent window (web planner)
   */
  sendEvent<K extends keyof LmEvents>(
    event: K,
    payload: LmEvents[K]
  ): void {
    this.log.info("Sending event to parent window", event)

    if (window.parent && window.parent !== window) {
      window.parent.postMessage(
        {
          lmEvent: event,
          payload: payload
        },
        // TODO revert back when HonzaP. is ready
        //environment.asamm.webPlannerUrl
        "*"
      );
    }
  }

  /** @deprecated Use `sendLogout` and `sendLogin` instead. This will be removed */
  notifyEmailChanged(newEmail: string): void {
    this.sendEvent(
      LmEventNames.FIREBASE_EMAIL_CHANGED,
      { email: newEmail }
    )
  }

  sendLogout(): void {
    this.sendEvent(LmEventNames.LOGOUT, {})
  }

  sendLogin(prefilledEmail?: string): void {
    this.sendEvent(LmEventNames.LOGIN, { email: prefilledEmail })
  }
}
